import { Component, EventEmitter, inject, Input, OnInit, Optional, Output } from '@angular/core'
import { ControlContainer, FormsModule, NgForm } from '@angular/forms'

import { AutoComplete } from 'primeng/autocomplete'
import { isEmpty, map, uniq } from 'lodash-es'

import { BudgetLinesApi } from '@app/apis/budget-lines.api'
import { DetailMode } from '@app/components/generic/generic.constants'
import { RequiredFieldTextComponent } from '@app/components/metadata/required-field-text.component'

@Component({
  selector: 'app-budget-line-field',
  templateUrl: 'budget-line-field.component.html',
  viewProviders: [{
    provide: ControlContainer,
    deps: [[Optional, NgForm]],
    useFactory: (ngForm: NgForm) => ngForm,
  }],
  imports: [
    AutoComplete,
    FormsModule,
    RequiredFieldTextComponent,
  ],
})
export class BudgetLinesFieldComponent implements OnInit {
  public readonly budgetLinesApi = inject(BudgetLinesApi)

  @Input() budgetLines?: string[]
  @Input() required: boolean = false
  @Input() recommended: boolean = false
  @Input() mode: string = 'normal'
  @Input() tabindex: number = -1

  @Output() budgetLinesChange = new EventEmitter<string[] | undefined>()

  public selectedBudgetLineCodes: string[] = []
  public allBudgetLineCodes: string[] = []

  protected readonly DetailMode = DetailMode
  protected readonly isEmpty = isEmpty

  ngOnInit(): void {
    this.selectedBudgetLineCodes = this.budgetLines ?? []
  }

  protected onBudgetLinesChange(budgetLines?: string[]) {
    this.budgetLines = this.normalizeBudgetLines(budgetLines ?? [])
    this.budgetLinesChange.emit(this.budgetLines)
  }

  /**
   * Perform several validations and alterations on the budget line values, removing invalid budget lines if they are found.
   */
  normalizeBudgetLines (budgetLines: string[]) {
    return budgetLines
      .map(budgetEntry => budgetEntry.trim())
      .map(budgetEntry => budgetEntry.toLocaleUpperCase())
      // Delete if more than 6 length.
      .filter(budgetEntry => budgetEntry.substring(0, 6))
      // Delete if less than 5 length.
      .filter(budgetEntry => budgetEntry.length >= 5)
      // Delete if contains non-capital alpha numeric characters
      .filter(budgetEntry => !/(?![A-Z0-9])./.test(budgetEntry))
  }

  getBudgetLineSuggestions ($event: { query: string, originalEvent: any }) {
    if (!$event.query) return
    const searchText = $event.query.toUpperCase()

    // we append the actual search text to the list of possible suggestions to allow the user to
    // enter any value, even when it is not in the list of known BLs
    this.budgetLinesApi.list({ limit: 100, ordering: 'budget_line_code', budget_line_code__startswith: searchText }).subscribe((res) => {
      this.allBudgetLineCodes = uniq(
        map(res.results, budgetLine => budgetLine.budget_line_code!).concat([searchText]),
      )
    })
  }
}
